import {
  ILoan,
  IWrapper,
  LoanDetailsResponse,
  LoanPaymentResponse,
  LoanPaymentDeferralPayload,
  LoanPaymentDeferralResponse,
  LoansSummary,
} from '../types';
import {PagingPayload} from '../constants';

/**
 * LoanEndpoint class implements ILoan interface
 */
class LoanEndpoint implements ILoan {
  readonly wrapper: IWrapper;

  /**
   * Constructor
   * @param {IWrapper} wrapper - The wrapper instance
   */
  constructor(wrapper: IWrapper) {
    this.wrapper = wrapper;
  }

  /**
   * Get loans summary
   */
  public getLoansSummary(): Promise<LoansSummary> {
    return this.wrapper.get<LoansSummary>('/v1/Loan', PagingPayload);
  }

  /**
   * Get loan details
   * @param {number} loanId
   */
  public getLoanDetails(loanId: number): Promise<LoanDetailsResponse> {
    return this.wrapper.get<LoanDetailsResponse>(`/v1/Loan/${loanId}`);
  }

  /**
   * Get loan payments
   * @param {number} loanId
   */
  public getLoanPayment(loanId: number): Promise<LoanPaymentResponse> {
    return this.wrapper.get<LoanPaymentResponse>(
      `/v1/Loan/GetPayment/${loanId}`,
      PagingPayload,
    );
  }

  /**
   * Post loan payment deferral
   * @param data
   */
  public postLoanPaymentDeferral(
    data: LoanPaymentDeferralPayload,
  ): Promise<LoanPaymentDeferralResponse> {
    return this.wrapper.post<LoanPaymentDeferralResponse>(
      '/v1/Loan/DeferPayment',
      data,
    );
  }
}

export default LoanEndpoint;
